import { useQuery } from "react-query";
import SchemaService from "../api/services/SchemaService";

export const useBondRecords = (
  data: any,
  cb: any,
  errorCb: any,
  accessKey: string
) => {
  return useQuery(
    ["bondRecords"],
    async () => await SchemaService.getBondRecords(data, accessKey),
    {
      keepPreviousData: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      onError(err) {
        errorCb(err);
      },
      onSuccess(data) {
        cb(data);
      },
      enabled: false,
    }
  );
};
